import React from "react";
import { Row, Col } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";

class SplittedScreen extends React.Component<any, any> {
  render() {
    return (
      <Row className={s.mainScreen}>
        <Col xs="12" sm="12" md="6" lg="6" className={s.leftSide}>
          <div className={s.logoImage + " " + s.hiddenLg} />
          {this.props.children}
        </Col>
        <Col
          xs="12"
          sm="12"
          md="6"
          lg="6"
          className={s.rightSide + " " + s.hiddenXs}
        >
          <div className={s.backgroundImage}>
            <div className={s.logoImage} />
          </div>
        </Col>
      </Row>
    );
  }
}

export default withStyles(s)(SplittedScreen);
